/** Where the settings shell is: the open category and record (from the route). */

import { createContext, useContext } from 'react';
import type { SettingsCategory } from './types.js';

export interface SettingsLocation {
  category: string;
  definition: SettingsCategory;
  /** The record in the URL (or the first item on desktop); 'new' for a new draft. */
  recordId: string | null;
  duplicateOf: string | null;
}

export const SettingsLocationContext = createContext<SettingsLocation | null>(null);

export function useSettingsLocation(): SettingsLocation | null {
  return useContext(SettingsLocationContext);
}
